import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import CancelIcon from '@material-ui/icons/Cancel'; // Import CancelIcon
import DescriptionIcon from '@material-ui/icons/Description';
import {
  Container,
  TextField,
  Button,
  Paper,
  Divider,
  Typography,
  Box,
  Grid,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 700,
    fontSize: '1.1rem',
    color: '#f57c00',
    marginBottom: '10px',
    marginTop: '10px'
  },
  paper: {
    padding: '20px',
    marginTop: '20px',
    marginBottom: '20px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
    backgroundColor: '#fff'
  },
  inputField: {
    width: '100%'
  },
  submitButton: {
    backgroundColor: '#f57c00',
    color: '#fff',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: '#d95d00'
    }
  },
  helperText: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    textAlign: 'right',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
    fontSize: '0.75rem'
  },
  fileIcon: {
    marginRight: '8px',
    fontSize: '1.5rem'
  },
  browseText: {
    cursor: 'pointer',
    fontWeight: 'bold',
    color: '#ccc',
    alignSelf: 'center'
  },
  fileList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginTop: '10px',
    justifyContent: 'flex-start'
  },
  fileItem: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '8px',
    maxWidth: '200px',
    boxSizing: 'border-box',
    marginBottom: '10px'
  },
  fileName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: '8px',
    fontSize: '0.875rem'
  }
}));

const ApplicationForm = () => {
  const classes = useStyles();
  const [fullName, setFullName] = useState('');
  const [whyThisRole, setWhyThisRole] = useState('');
  const [job, setJob] = useState('');
  const [attachments, setAttachments] = useState([]);

  const location = useLocation();
  const ixJob = location.state?.ixJob || localStorage.getItem('ixJob');

  useEffect(() => {
    const savedPayload = JSON.parse(localStorage.getItem('userPayload'));
    if (savedPayload) {
      setFullName(savedPayload.portal_user?.full_name || '');
    }
    const urlParams = new URLSearchParams(window.location.search);
    const jobFromUrl = urlParams.get('ixJob');
    setJob(jobFromUrl || ixJob || '');
  }, [ixJob]);

  const handleFileChange = event => {
    const files = Array.from(event.target.files);
    setAttachments(prev => [...prev, ...files]);
  };

  const handleRemoveFile = fileName => {
    setAttachments(prev => prev.filter(file => file.name !== fileName));
  };

  const handleSubmit = () => {
    alert('Application submitted!');
  };

  return (
    <Container maxWidth="xl">
      <Typography variant="h3" color="primary" style={{ fontWeight: 'bold' }}>
        <DescriptionIcon style={{ marginRight: '10px' }} />
        New Job Application
      </Typography>
      <Divider style={{ marginTop: '10px', marginBottom: '15px' }} />

      <Paper className={classes.paper}>
        <Typography className={classes.sectionHeader}>Personal Info</Typography>
        <Divider style={{ marginTop: '10px', marginBottom: '15px' }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Full Name"
              variant="outlined"
              size="medium"
              className={classes.inputField}
              value={fullName}
              onChange={e => setFullName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Email"
              variant="outlined"
              size="medium"
              className={classes.inputField}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Contact Number "
              variant="outlined"
              size="medium"
              className={classes.inputField}
            />
          </Grid>
        </Grid>

        <Typography className={classes.sectionHeader}>Job Type</Typography>
        <Divider style={{ marginTop: '10px', marginBottom: '15px' }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Job Type"
              variant="outlined"
              size="medium"
              className={classes.inputField}
              value={job}
              onChange={e => setJob(e.target.value)}
            />
          </Grid>
        </Grid>
        <Typography className={classes.sectionHeader}>
          Working Experience
        </Typography>
        <Divider style={{ marginTop: '10px', marginBottom: '15px' }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Company Name"
              variant="outlined"
              size="medium"
              className={classes.inputField}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Addess "
              variant="outlined"
              size="medium"
              className={classes.inputField}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Details "
              variant="outlined"
              size="medium"
              className={classes.inputField}
            />
          </Grid>
        </Grid>
        <Typography className={classes.sectionHeader}>Education</Typography>
        <Divider style={{ marginTop: '10px', marginBottom: '15px' }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="University / School"
              variant="outlined"
              size="medium"
              className={classes.inputField}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Year Graduated  "
              variant="outlined"
              size="medium"
              className={classes.inputField}
            />
          </Grid>
        </Grid>

        <Typography className={classes.sectionHeader}>
          Your Background
        </Typography>
        <Divider style={{ marginTop: '10px', marginBottom: '15px' }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Why this Role?"
              variant="outlined"
              size="medium"
              multiline
              rows={3}
              value={whyThisRole}
              onChange={e => setWhyThisRole(e.target.value)}
              className={classes.inputField}
            />
          </Grid>
        </Grid>

        {/* Attachments Section */}
        <Typography className={classes.sectionHeader}>Attachments</Typography>
        <Divider style={{ marginTop: '10px', marginBottom: '15px' }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">
              Please attach your documents here.
            </Typography>

            <Box
              border="2px dashed #ccc"
              borderRadius="4px"
              p={4}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
            >
              <InsertDriveFileIcon
                style={{ fontSize: 80, color: '#ccc', cursor: 'pointer' }}
                onClick={() => document.getElementById('fileInput').click()}
              />
              <input
                id="fileInput"
                type="file"
                hidden
                multiple
                onChange={handleFileChange}
              />
              <Typography
                variant="body1"
                className={classes.browseText}
                onClick={() => document.getElementById('fileInput').click()}
              >
                Browse
              </Typography>

              <div className={classes.fileList}>
                {attachments.map((file, index) => (
                  <div key={index} className={classes.fileItem}>
                    <InsertDriveFileIcon className={classes.fileIcon} />
                    <Typography variant="body2" className={classes.fileName}>
                      {file.name}
                    </Typography>
                    <CancelIcon
                      className={classes.removeButton}
                      onClick={() => handleRemoveFile(file.name)}
                    />
                  </div>
                ))}
              </div>
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12} style={{ textAlign: 'right', marginTop: '20px' }}>
          <Button
            className={classes.submitButton}
            variant="contained"
            onClick={handleSubmit}
          >
            Submit Application
          </Button>
        </Grid>
      </Paper>
    </Container>
  );
};

export default ApplicationForm;
